module.exports = __webpack_public_path__ + "static/media/stationary2Modal.6b7f2cf2.jpg";